import { Switch as AntdSwitch, type SwitchProps as AntdSwitchProps } from "antd";

import type { AvE2EProps } from "../types";

type SwitchProps = AntdSwitchProps & AvE2EProps;

function Switch({ testIdPrefix, ...restProps }: SwitchProps) {
  return <AntdSwitch data-testid={`${testIdPrefix}-switch`} {...restProps} />;
}

export { Switch };
export type { SwitchProps };
